import moment from 'moment';

/**
 * Formats a timestamp according to business rules:
 * - Concise relative format for posts within 7 days (e.g. "5h", "2d")
 * - Concise absolute format for posts older than 7 days (e.g. "Jun 4 2:30 PM")
 * - Full format in tooltip
 * 
 * @param {string|Date} timestamp - The timestamp to format
 * @returns {Object} - Object containing formatted strings and tooltip
 */
export const formatTimestamp = (timestamp) => {
  const date = moment(timestamp);
  const now = moment();
  const daysDiff = now.diff(date, 'days');

  const tooltipTime = date.format('MMMM D, YYYY h:mm A');

  let displayTime;
  if (daysDiff < 7) {
    if (daysDiff === 0) {
      const hoursDiff = now.diff(date, 'hours');
      if (hoursDiff === 0) {
        const minutesDiff = now.diff(date, 'minutes');
        if (minutesDiff === 0) {
          displayTime = 'now';
        } else {
          displayTime = `${minutesDiff}m`;
        }
      } else {
        displayTime = `${hoursDiff}h`;
      }
    } else {
      displayTime = `${daysDiff}d`;
    }
  } else {
    displayTime = date.format('MMM D h:mm A');
  }

  return {
    displayTime,
    tooltipTime
  };
}; 